import { __assign } from "tslib";
import { createFakeGetResponder, createFakePostResponder, createFakePutResponder, createFakeDeleteResponder } from '../../test-utils';
import { createRuleEngineApi, ruleEngineRelativePath } from './';
import { createHttpTestKit } from '../../http/test-kit';
export var createRuleEngineApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createRuleEngineApi('', fakeHttp);
    var testKit = {
        whenGetRules: function () { return createFakeGetResponder(fakeHttp, ruleEngineRelativePath); },
        whenAddRule: function (dto) { return createFakePostResponder(fakeHttp, ruleEngineRelativePath)(dto); },
        whenUpdateRule: function (dto) { return createFakePutResponder(fakeHttp, ruleEngineRelativePath + "/" + (dto === '*' ? 'bob' : dto.id))(dto); },
        whenEnableRule: function (dto) { return createFakePostResponder(fakeHttp, ruleEngineRelativePath + "/" + (dto === '*' ? 'bob' : dto.id) + "/enable")(dto); },
        whenDisableRule: function (dto) { return createFakePostResponder(fakeHttp, ruleEngineRelativePath + "/" + (dto === '*' ? 'bob' : dto.id) + "/disable")(dto); },
        whenDeleteRule: function (dto) { return createFakeDeleteResponder(fakeHttp, ruleEngineRelativePath + "/" + (dto === '*' ? 'bob' : dto.id)); },
        whenReorderRules: function (dto) { return createFakePostResponder(fakeHttp, ruleEngineRelativePath + "/reorder")(dto); },
        calls: function () { return fakeHttp.calls(); }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map